import { withInternal } from '../auth/withAuth';

import { ModelIoPage } from './ModelIoPage';

export default withInternal(function ModelIoInputPage() {
  return <ModelIoPage type="output" />;
});
